import { useEffect, useRef } from 'react';
import { zoom, zoomIdentity } from 'd3-zoom';
import { select } from 'd3-selection';
var SCALE_MAX = 1.5;
var SCALE_MIN = 0.5;
var SHRINK_TO_FIT_PADDING = 0.8;
var ZOOM_TRANSFORM_DURATION = 100;
var CENTER_FIT_TRANSFORM_DURATION = 500;
export var ZOOM_IN_OUT_INCREMENT = 0.05;
export var DEFAULT_CANVAS_WIDTH = 1000;
export var DEFAULT_CANVAS_HEIGHT = 500;
export var CANVAS_CONTAINER_CLASSNAME = 'interactiveCanvas__container';
export var useInteractiveCanvasHelpers = function (transform, setTransform) {
    var d3CanvasSelectionRef = useRef();
    var canvasContentRef = useRef(null);
    var zoomBehavior = useRef();
    var resetCanvasTransform = function (newTransform) {
        if (d3CanvasSelectionRef.current && zoomBehavior.current) {
            d3CanvasSelectionRef.current
                .call(zoomBehavior.current.transform, newTransform);
        }
    };
    useEffect(function () {
        zoomBehavior.current = zoom()
            .scaleExtent([SCALE_MIN, SCALE_MAX])
            .on('zoom', function (e) {
            setTransform(e.transform);
        });
        d3CanvasSelectionRef.current = select('.' + CANVAS_CONTAINER_CLASSNAME);
        d3CanvasSelectionRef.current
            .call(zoomBehavior.current.transform, transform)
            .call(zoomBehavior.current)
            .on('dblclick.zoom', null);
    }, []);
    var getCenterTransformAtScale = function (scale) {
        var _a, _b, _c;
        var canvasRect = (_b = (_a = d3CanvasSelectionRef.current) === null || _a === void 0 ? void 0 : _a.node()) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        var canvasContentBBox = (_c = canvasContentRef.current) === null || _c === void 0 ? void 0 : _c.getBBox();
        if (!canvasRect || !canvasContentBBox) {
            return null;
        }
        var canvasMidPointX = canvasRect.width * 0.5;
        var canvasMidPointY = canvasRect.height * 0.5;
        var contentMidPointX = canvasContentBBox.x + canvasContentBBox.width * 0.5;
        var contentMidPointY = canvasContentBBox.y + canvasContentBBox.height * 0.5;
        return zoomIdentity
            .translate(canvasMidPointX - contentMidPointX * scale, canvasMidPointY - contentMidPointY * scale)
            .scale(scale);
    };
    var doCenterTransition = function () {
        var centerTransform = getCenterTransformAtScale(transform.k);
        doTransitionToNewTransform(centerTransform);
    };
    var doFitTransition = function () {
        var _a, _b, _c;
        var canvasRect = (_b = (_a = d3CanvasSelectionRef.current) === null || _a === void 0 ? void 0 : _a.node()) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        var canvasContentBBox = (_c = canvasContentRef.current) === null || _c === void 0 ? void 0 : _c.getBBox();
        if (!canvasRect || !canvasContentBBox) {
            return;
        }
        var scaleToFit = SHRINK_TO_FIT_PADDING / Math.max(canvasContentBBox.width / canvasRect.width, canvasContentBBox.height / canvasRect.height);
        var clampedScaleToFit = Math.min(Math.max(scaleToFit, SCALE_MIN), SCALE_MAX);
        var scaleToFitTransform = getCenterTransformAtScale(clampedScaleToFit);
        doTransitionToNewTransform(scaleToFitTransform);
    };
    var doTransitionToNewTransform = function (newTransform) {
        var _a;
        if (newTransform === null) {
            return;
        }
        d3CanvasSelectionRef.current
            .transition("zoomTransform." + Date.now())
            .duration(CENTER_FIT_TRANSFORM_DURATION)
            .call((_a = zoomBehavior.current) === null || _a === void 0 ? void 0 : _a.transform, newTransform);
    };
    var doZoomTransition = function (zoomAmount) {
        var _a;
        if (d3CanvasSelectionRef.current) {
            d3CanvasSelectionRef.current
                .transition("zoomTransform." + Date.now())
                .duration(ZOOM_TRANSFORM_DURATION)
                .call((_a = zoomBehavior.current) === null || _a === void 0 ? void 0 : _a.scaleTo, transform.k + zoomAmount);
        }
    };
    return {
        canvasContentRef: canvasContentRef,
        doZoomTransition: doZoomTransition,
        doCenterTransition: doCenterTransition,
        doFitTransition: doFitTransition,
        resetCanvasTransform: resetCanvasTransform,
    };
};
//# sourceMappingURL=useInteractiveCanvasHelpers.js.map